module.exports = __webpack_public_path__ + "img/password-login.fcc71219.svg";